export enum SourceTypes {
  TRIAL = 'trial',
  STRIPE = 'stripe',
  BAGGINS = 'baggins',
  TPINTEGRATION = 'tpintegration'
}